export function isElectron() {
  return (window.electron && process.env.target === 'electron') || false;
}
